import { render } from "./CartProductsComponent.vue?vue&type=template&id=36689541&scoped=true"
import script from "./CartProductsComponent.vue?vue&type=script&lang=js"
export * from "./CartProductsComponent.vue?vue&type=script&lang=js"

import "./CartProductsComponent.vue?vue&type=style&index=0&id=36689541&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36689541"]])

export default __exports__